import styled from '@emotion/styled';

export const MaxLengthDisplay = styled.span`
  margin-bottom: 8px;
  font-size: 12px;
  font-style: italic;
`;
